// extracted by mini-css-extract-plugin
export var card = "_k7-5";
export var cardSelected = "_k7-4";
export var image = "_k7-3";
export var modal = "_k7-0";
export var modalContent = "_k7-1";
export var table = "_k7-2";